const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#36447F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.7,56.7c2.3,0,3.8,0.4,4.6,1.3c0.8,0.8,0.9,2.3,0.5,4.3c-0.4,2.1-1.2,3.7-2.4,4.6      s-3,1.4-5.4,1.4h-3.7l2.2-11.6C37.5,56.7,41.7,56.7,41.7,56.7z M27,80h6l1.4-7.4h5.2c2.3,0,4.1-0.2,5.6-0.7s2.8-1.3,4-2.4      c1-0.9,1.8-2,2.5-3.1c0.6-1.1,1.1-2.4,1.3-3.7c0.6-3.3,0.2-5.8-1.4-7.7c-1.6-1.8-4.1-2.7-7.6-2.7H32.4L27,80z",
    style: {
      fill: "#C9D5F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,45h6l-1.4,7.4H69c3.3,0,5.7,0.6,6.9,1.8c1.3,1.2,1.7,3.1,1.1,5.7l-2.5,12.9h-6.1l2.4-12.2      c0.3-1.4,0.2-2.3-0.3-2.8S69,57,67.5,57h-4.8l-3.1,15.8h-6L59.1,45z",
    style: {
      fill: "#C9D5F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,56.7c2.3,0,3.8,0.4,4.6,1.3c0.8,0.8,0.9,2.3,0.5,4.3c-0.4,2.1-1.2,3.7-2.4,4.6      c-1.2,0.9-3,1.4-5.4,1.4H84l2.2-11.6C86.2,56.7,90.4,56.7,90.4,56.7z M75.7,80h6l1.4-7.4h5.2c2.3,0,4.1-0.2,5.6-0.7      s2.8-1.3,4-2.4c1-0.9,1.8-2,2.5-3.1c0.6-1.1,1.1-2.4,1.3-3.7c0.6-3.3,0.2-5.8-1.4-7.7c-1.6-1.8-4.1-2.7-7.6-2.7H81.1L75.7,80z",
    style: {
      fill: "#C9D5F7"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.2ebfd6dbd5ae2432e0a051e25424b30a.svg";
export { ForwardRef as ReactComponent };